module.exports = __webpack_public_path__ + "static/media/IMG_20240517_154302-min.45d4f8ea.jpg";